import { apiClient } from "../api/apiclient"

export const getCourse = (token) =>
    apiClient.get("/courses", {
        headers: { Authorization: `Bearer ${token}` },
    });

export const postBulkStudent = (studentId, courseId, token) =>
    apiClient.post("/api/student-applications/create", {
        headers: { Authorization: `Bearer ${token}` },
        params: { studentId, courseId },
    });

export const getStudentDetails = (token) =>
    apiClient.get("/student-details/all", {
        headers: { Authorization: `Bearer ${token}` },
    });


export const getAllStudentBulk = (token) =>
    apiClient.get("/api/student-applications/get-all", {
        headers: { Authorization: `Bearer ${token}` },
    });


export const getStudentsByCourse = (courseId, token) =>
    apiClient.get("/api/student-applications/by-course", {
        headers: { Authorization: `Bearer ${token}` },
        params: { courseId },
    });


export const VerifyStudents = (token, applicationNumbers) =>
    apiClient.patch("/api/student-applications/verify", applicationNumbers,
        {
            headers: { Authorization: `Bearer ${token}` },
        });

export const getStudentsDeatils = (studentIds, token) =>
    apiClient.get("/details", studentIds, {
        headers: { Authorization: `Bearer ${token}` },
    });


export const getStudentPhotosign = (token) =>
    apiClient.get("/getimages", {
        headers: { Authorization: `Bearer ${ token }` },
        responseType:"blob"
        });

// export const getStudentsByStudentId = (token,studentId)
//     apiClient.get("/student-details",{
//         headers: { Authorization: `Bearer ${token}` },
//         params: { studentId},
//     });  


export const getStudentsAllData = (studentId, courseId, token) =>
    apiClient.get("/student-data", {
        headers: { Authorization: `Bearer ${token}` },
        params: { studentId, courseId },
    });

export const getDocuments = (studentId, courseId, token) =>
    apiClient.get("/document/course", {
        headers: { Authorization: `Bearer ${token}` },
        params: { studentId, courseId },
    });